"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getInteractionKey_1 = require("../../helpers/getInteraction/getInteractionKey");
const getStateInteraction_1 = require("../../helpers/getStateInteraction");
const entity_1 = require("../../type/entity");
function updateExistingStateInteractions(currentSubmission, removedReviewerIds, rootContentId, timeStamp, stateInteractions) {
    const interactionKeysForLearner = (removedReviewerIds || []).map(reviewerId => getInteractionKey_1.getInteractionKeyForLearner(rootContentId, entity_1.InteractionType.Evaluation, currentSubmission.submissionId, reviewerId));
    let currentStateInteractions = interactionKeysForLearner.map(key => getStateInteraction_1.getStateInteractionByInteractionKeyForLearner(stateInteractions, key));
    currentStateInteractions = currentStateInteractions.map((stateInteraction) => {
        if (stateInteraction) {
            stateInteraction.deleted = true;
            stateInteraction.updatedAt = timeStamp;
        }
        return stateInteraction;
    });
}
exports.updateExistingStateInteractions = updateExistingStateInteractions;
//# sourceMappingURL=updateExistingStateInteractions.js.map